<template>
  <div>
    <v-dialog scrollable persistent v-model="model" max-width="600">
      <material-card
        :title="
          $t(
            'components.claims.claims_payments_table.cancel_payment_title_{0}',
            [payment.PaymentNumber]
          )
        "
        :color="$vuetify.theme.themes.light.warning"
        icon="done"
        v-if="model"
      >
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-container>
              <div class="row">
                <div class="col-12 col-sm-8">
                  <v-textarea
                    v-model="cancellationPayload.Explanation"
                    :label="$t('components.claims_history.header.explanation')"
                    :rules="[$rules.required]"
                    class="required"
                  ></v-textarea>
                  <!-- <trans-textarea
                    v-model="cancellationPayload"
                    :label="$t('components.claims_history.header.explanation')"
                    field="Explanation"
                    :rules="[$rules.required]"
                    class="required"
                    :dialog="model"
                  ></trans-textarea> -->
                </div>
                <div class="col-12 col-sm-4">
                  <v-checkbox
                    v-model="cancellationPayload.SendNotification"
                    :label="
                      $t('components.claims.cancel_payment.send_notification')
                    "
                    disabled
                  ></v-checkbox>
                </div>
              </div>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="cancelDialog = true">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="primary" @click="tryCancelPayment" :disabled="!valid">
            {{
              $t(
                "components.claims.claims_payments_table.cancel_payment_action"
              )
            }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="cancelDialog" persistent max-width="400">
      <material-card
        :title="
          $t('components.claims.claims_payments_table.cancel_cancellation')
        "
        :color="$vuetify.theme.themes.light.warning"
        icon="cancel"
      >
        <v-card-text>
          {{ $t("globals.are_you_sure") }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="cancelDialog = false">
            {{ $t("components.claim_submission.keep_editing") }}
          </v-btn>
          <v-btn color="primary" text @click="close">
            {{ $t("globals.close") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="loading" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <error-handler :error="error" />
  </div>
</template>

<script>
import TransTextarea from "../TransTextarea.vue";
import ErrorHandler from "../ErrorHandler.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: { TransTextarea, ErrorHandler },
  props: ["payment", "model"],
  data() {
    return {
      cancellationPayload: null,
      cancelDialog: false,
      loading: false,
      error: null,
      valid: false,
    };
  },
  // mounted() {
  //   console.log("mounted: ", this.payment);
  //   if (this.payment !== null && this.payment !== undefined) {
  //     this.cancellationPayload = {
  //       PaymentId: this.payment.Id,
  //       Explanation: null,
  //       SendNotification: false,
  //     };
  //   }
  // },
  computed:{
    ...mapGetters("common", ["language"]),
  },
  watch: {
    model: {
      handler(v) {
        if (v) {
          this.cancellationPayload = {
            Explanation: null,
            SendNotification: false,
          };
          // this.$forceUpdate();
        }
      },
    },
  },
  methods: {
    ...mapActions("claims", ["cancelPayment"]),
    close() {
      this.cancelDialog = false;
      this.cancellationDialog = false;
      this.$emit("cancel");
    },
    async tryCancelPayment() {
      try {
        this.loading = true;
        let payload = JSON.parse(JSON.stringify(this.cancellationPayload));
        payload.PaymentId = this.payment.Id;
        // payload.Explanation = payload.Translations.filter(o=>o.LanguageCode === this.language.language)[0].Explanation;
        await this.cancelPayment({
          payload: payload,
        });
        this.$emit("success");
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
